<footer class="ao-footer">
	<hr />
	<div class="footer-flexbox">
		<div class="contact-us">
			<a href="https://www.auto-owners.com/about/contact-us" target="_self">Contact Us</a>
		</div>
		<p class="ao-fine-print support">Support <a href="tel:8442670864">844.267.0864</a></p>
		<div class="links-flexbox ao-fine-print">
			<a href="https://www.auto-owners.com/privacy" target="_self">Privacy Policy</a>
			<span class="ao-ash ao-left-16 ao-right-16 spacing-circle">&#9679;</span>
			<a href="https://www.auto-owners.com/terms-of-use" target="_self">Terms of Use</a>
			<span class="ao-ash ao-left-16 ao-right-16 spacing-circle">&#9679;</span>
			<a href="https://www.auto-owners.com/accessibility" target="_self">Accessibility</a>
		</div>
		<p class="copyright ao-fine-print">&copy; {{ year }} Auto-Owners Insurance. All Rights Reserved.</p>
		<div class="logo-tagline">
			<img [src]="aoLogoTaglineSrc" alt="Auto-Owners Logo" crossorigin="anonymous" />
		</div>
	</div>
</footer>
